// The typed client of the app API and of the login routes. The types come from the routes: `AppType`.
import { hc } from "hono/client";
import type { AppType } from "../src/index";
import { errorText } from "./dom";

export const client = hc<AppType>(location.origin);

// Waits for the response. Returns it when its status is 2xx. Otherwise, gives the error message
// to `fail` and returns `null`.
export async function succeeded<R extends { ok: boolean; json(): Promise<unknown> }>(
  request: Promise<R>,
  fail: (message: string) => void,
  fallback: string,
): Promise<Extract<R, { ok: true }> | null> {
  const response = await request.catch(() => null);
  if (!response) fail("The connection failed. Try again.");
  else if (!response.ok) fail(await errorText(response, fallback));
  else return response as Extract<R, { ok: true }>;
  return null;
}
